<template>
  <div>
    <Head title="Dashboard" />
    <template>
      <v-card >
        <v-tabs
          v-model="tab"
          background-color="primary"
          centered
          
          icons-and-text
        >
          <v-tabs-slider></v-tabs-slider>

          <v-tab href="#tab-1" >
            <span color="white--text" style="color:white !important">Profile</span>
            <v-icon color="white">mdi-account-outline</v-icon>
          </v-tab>

          <v-tab href="#tab-2" color="primary">
            <span color="white--text" style="color:white !important">Saved Jobs</span>
            <v-icon color="white">mdi-hand-heart</v-icon>
          </v-tab>
          <v-tab href="#tab-3" color="primary">
            <span color="white--text" style="color:white !important">Saved Courses</span>
            <v-icon color="white">mdi-head-heart</v-icon>
          </v-tab>
          <v-tab href="#tab-4" color="primary">
            <span color="white--text" style="color:white !important">Resources</span>
            <v-icon color="white">mdi-download</v-icon>
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item
            
            :key="1"
            value="tab-1"
          >
            <ProfileEditor :categories="categories" :usermeta="usermeta" :baseurl="baseurl" :auth="auth" :state="state"></ProfileEditor>
          </v-tab-item>
          <v-tab-item
            
            :key="2"
            value="tab-2"
          >
            <v-container>
              <FavoriteJobs :baseurl="baseurl" :auth="auth" :state="state"></FavoriteJobs>
            </v-container>
          </v-tab-item>
          <v-tab-item
            
            :key="3"
            value="tab-3"
          >
            <v-container>
              <FavoriteCourses :baseurl="baseurl" :auth="auth" :state="state"></FavoriteCourses>
            </v-container>
          </v-tab-item>
          <v-tab-item
            
            :key="4"
            value="tab-4"
          >
            <v-card flat>
              <v-card-title>Resources</v-card-title>
              <v-card-text>
                <v-alert type="info">Resources will be added to this page periodically, or as you attend events.</v-alert>
                <Resources :baseurl="baseurl" :auth="auth" :state="state"></Resources>
              </v-card-text>
            </v-card>
          </v-tab-item>

        </v-tabs-items>
      </v-card>
    </template>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue'
import Layout from '@/Shared/VuetifyLayout'
import ProfileEditor from '@/Shared/ProfileEditor'
import FavoriteJobs from '../../Shared/FavoriteJobs.vue'
import FavoriteCourses from '../../Shared/FavoriteCourses.vue'
import Resources from '../../Shared/Resources.vue'

export default {
  
  props: {
    auth: Object,
    state: String,
    baseurl: String,
    usermeta: Array,
    categories: Array,
  },
  components: {
    Head,
    ProfileEditor,
    FavoriteJobs,
    FavoriteCourses,
    Resources
  },
  layout: Layout,
  data() {
    return {
      tab: null
    }
  }
}
</script>
